<template>
  <div id="page_productInfo">
    <div id="part1">
      <div class="left">
        <img :src="`${$https}${proList.shopImgList[imgIndex]}`" alt="" class="mainimg">
        <div class="imgbox">
          <swiper class="swiper1" ref="swiper1" :options="swp1opt" :auto-update='true'>
            <swiper-slide class="item" v-for="(item,index) in proList.shopImgList" :key="index">
              <img :class="index==imgIndex?'on':''" :src="`${$https}${item}`" alt="" @click="imgIndex=index">
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <div class="right">
        <div class="mainTitle1 textbox">
          <h3>{{proList.shopTitle}}</h3>
          <p>{{proList.shopDesc}}</p>
        </div>
<!--        <dl v-for="(item,index) in proList.shopAttribute" :key="index">-->
<!--          <dd>{{item.name}}</dd>-->
<!--          <dd>{{item.value}}</dd>-->
<!--        </dl>-->
        <div class="btnbox">
          <div class="mainBtn1 hbutton_isi" @click="showform()">INQUIRY</div>
          <router-link to="/Product" class="mainBtn3 hbutton_isi" v-show="chatLink!=''">COLOR CHAT</router-link>
        </div>
        <el-dialog class="dialog" :visible.sync="dialogFormVisible">
          <div slot="title" class="dialog-title mainTitle1">
            <h3>Inquiry</h3>
          </div>
          <el-form :model="form">
            <el-form-item>
              <el-input v-model="form.name" autocomplete="off" placeholder="Name"></el-input>
              <el-input v-model="form.email" autocomplete="off" placeholder="E-mail"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="form.tel" autocomplete="off" placeholder="Phone Number"></el-input>
              <div style="display: flex;justify-content: space-between;align-items: center;width: 48.5%;">
                <el-input class="sms" v-model="form.VerifyCode" autocomplete="off" placeholder="VerifyCode"></el-input>
                <img class="smsimg" :src="smsList.imgData" alt="">
              </div>
            </el-form-item>
            <el-form-item>
              <el-input v-model="form.CnN" autocomplete="off" placeholder="Company Name"></el-input>
              <el-input v-model="form.CnR" autocomplete="off" placeholder="Country/Region"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input type="textarea" v-model="form.message" cols="30" rows="10" placeholder="Message"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <div class="hbutton_isi mainBtn1" @click="submit()" v-loading="loading">INQUIRY</div>
          </div>
        </el-dialog>
        <div class="sharebox">
          <span>Share To:</span>
          <i class="iconfont icon-shejiaotubiao-14" @click="goPage(1)"></i>
          <i class="iconfont icon-ins" @click="goPage(2)"></i>
          <i class="iconfont icon-youtube"></i>
          <i class="iconfont icon-facebook" @click="goPage(4)"></i>
        </div>
      </div>
    </div>
    <div class="collapsebox">
      <div class="probox">
        <el-collapse class="item" v-model="activeNames[0]">
          <el-collapse-item name="1">
            <template slot="title">
              <div class="mainTitle1">
                <h3>Product Parameter</h3>
              </div>
            </template>
            <dl v-for="(item,index) in proList.shopAttribute" :key="index">
              <dd>{{item.name}}</dd>
              <dd>{{item.value}}</dd>
            </dl>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="probox detail">
        <el-collapse class="item" v-model="activeNames[1]">
          <el-collapse-item name="1">
            <template slot="title">
              <div class="mainTitle1">
                <h3>Details</h3>
              </div>
            </template>
            <dl v-for="(item,index) in detailList.Details" :key="index">
              <dd class="left">
                <div class="textbox">
                  <div class="num">0{{ index+1 }}.</div>
                  <h4>{{ item.list[0] }}</h4>
                  <p>{{item.list[1]}}</p>
                </div>
              </dd>
              <dd class="right">
                <img :src="item.list[2]" alt="">
              </dd>
            </dl>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="probox custom">
        <el-collapse class="item" v-model="activeNames[2]">
          <el-collapse-item name="1">
            <template slot="title">
              <div class="mainTitle1">
                <h3>Customization</h3>
              </div>
            </template>
            <div class="itembox">
              <div class="item">
                <img src="../assets/img/productInfo_cusicon1.png" alt="">
                <div class="textbox">
                  <h4>Color</h4>
                  <p>Brotex comes with a wide range of colors and finishes, including wood textures, with available customization, to help you achieve the look you need while you build noise reduction into your spaces.</p>
                </div>
              </div>
              <div class="item">
                <img src="../assets/img/productInfo_cusicon2.png" alt="">
                <div class="textbox">
                  <h4>Texture</h4>
                  <p>Brotex offering an expansive library of sound attenuating products and accessory options. These utilize our sustainably sourced, 100% recyclable, lightweight and durable high-performance material.</p>
                </div>
              </div>
              <div class="item">
                <img src="../assets/img/productInfo_cusicon3.png" alt="">
                <div class="textbox">
                  <h4>Size</h4>
                  <p>You can choose the size of the customized sound-absorbing panel according to your needs, and we can provide you with a customized size service.</p>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <div id="part3">
      <div class="mainTitle1 textbox">
        <h3>Applications</h3>
      </div>
      <div class="itembox">
        <div class="item" v-for="(item,index) in applicationList" :key="index">
          <img :src="item.img" alt="">
          <div class="cover">{{item.name}}</div>
        </div>
      </div>
    </div>
    <div id="part5">
      <div class="mainTitle1 textbox">
        <h3>Related Products</h3>
      </div>
      <div class="contentbox">
        <swiper class="swiper2" ref="swiper2" :options="swp2opt" :auto-update='true'>
          <swiper-slide v-for="(item,index) in relatedList" :key="index">
            <router-link class="item" :to="{path:'./ProductInfo',query:{id:item.id,cin:0,}}">
              <div class="imgbox">
                <i class="triangle-topleft"></i>
                <img :src="`${$https}${item.img}`" alt="">
                <i class="triangle-topright"></i>
                <div class="cover"></div>
              </div>
              <p>{{item.name}}</p>
            </router-link>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination swppage1"></div>
      </div>
    </div>
<!--    <div id="part6">-->
<!--      <div class="mainTitle1 textbox">-->
<!--        <h3>Production Flow</h3>-->
<!--      </div>-->
<!--      <div class="itembox">-->
<!--        <div class="item" v-for="(item,index) in flowList" :key="index">-->
<!--          <img :src="item.img" alt="">-->
<!--          <p>{{ item.name }}</p>-->
<!--        </div>-->
<!--      </div>-->

<!--    </div>-->
  </div>
</template>

<script>
import {WOW} from 'wowjs'
import * as $request from "../api/index";
export default {
  name: "ProductInfo",
  metaInfo:{
    title:'Guangdong Brotex Acoustic Technology Co.,Ltd | ProductInfo',
  },
  data(){
    return{
      dialogFormVisible:false,
      loading:false,
      form:{
        name: '',
        email: '',
        tel: '',
        CnN: '',
        CnR: '',
        VerifyCode: '',
        message:'',
      },
      imgIndex:0,
      proList:{
        id:0,
        imgList:[require('../assets/img/index_hotimg1.jpg'),require('../assets/img/index_hotimg1.jpg'),require('../assets/img/index_hotimg1.jpg'),require('../assets/img/index_hotimg1.jpg'),],
        name:'Perforated Acoustic Panel',
        desc:'Perforated acoustic panels are very aesthetic and functional. They\'re almost invisible acoustic material with high absorption. Up to 600’000 holes every m² possible.',
        attrList1:[
          {
            name:'Thickness',
            value:'normal 15mm',
          },
          {
            name:'Environmental protection level',
            value:'national standard E1',
          },
          {
            name:'Fire rating',
            value:'national standard A',
          },
          {
            name:'Sound absorption coefficient',
            value:'NRC=0.70',
          },
          {
            name:'Size',
            value:'1200 * 600 mm / 600 * 600 mm',
          },
        ],
        detailList:[
          {
            name:'Feature',
            text:'Microperforated wood ceiling and wall panels control noise with 0.55 mm perforations that disappear from a normal viewing distance. ',
            img:'',
          },
          {
            name:'Material',
            text:'Acoustic fabric is factory-attached to the back of the panels and optional ',
            img:'',
          },
          {
            name:'Advantage',
            text:'Acoustic insulation provides NRC performance up to 0.80 for ceilings.And the Standard perforation types are 2/2/0.5 with 250’000 holes/m².',
            img:'',
          },
        ],
      },
      applicationList:[
        // {
        //   name:'Indoor Stadium',
        //   img:require('../assets/img/application_bg6.jpg'),
        // },
        {
          name:'Office',
          img:require('../assets/img/application_bg1.jpg'),
        },
        {
          name:'School',
          img:require('../assets/img/application_bg2.jpg'),
        },
        {
          name:'Auditorium',
          img:require('../assets/img/application_bg3.jpg'),
        },
        {
          name:'Commercial',
          img:require('../assets/img/application_bg4.jpg'),
        },
        {
          name:'Indoor Stadium',
          img:require('../assets/img/application_bg5.jpg'),
        },
      ],
      flowList:[
        {
          img:require('../assets/img/productInfo_flow1.png'),
          name:'CUTTING',
        },
        {
          img:require('../assets/img/productInfo_flow1.png'),
          name:'HOLE DRILLING',
        },
        {
          img:require('../assets/img/productInfo_flow1.png'),
          name:'WELDING',
        },
        {
          img:require('../assets/img/productInfo_flow1.png'),
          name:'POLISHING',
        },
        {
          img:require('../assets/img/productInfo_flow1.png'),
          name:'ASSEMBLY',
        },
        {
          img:require('../assets/img/productInfo_flow1.png'),
          name:'PACKING',
        },
      ],
      swp1opt:{
        slidesPerView: 4,
        spaceBetween: 10,
      },
      relatedList:[
        {
          id:0,
          img:require('../assets/img/index_hotimg1.jpg'),
          name:'1Perforated Acoustic Panel',
        },
        {
          id:0,
          img:require('../assets/img/index_hotimg1.jpg'),
          name:'2Perforated Acoustic Panel',
        },
        {
          id:0,
          img:require('../assets/img/index_hotimg1.jpg'),
          name:'3Perforated Acoustic Panel',
        },
        {
          id:0,
          img:require('../assets/img/index_hotimg1.jpg'),
          name:'4Perforated Acoustic Panel',
        },
        {
          id:0,
          img:require('../assets/img/index_hotimg1.jpg'),
          name:'5Perforated Acoustic Panel',
        },
        {
          id:0,
          img:require('../assets/img/index_hotimg1.jpg'),
          name:'6Perforated Acoustic Panel',
        },
      ],
      swp2opt:{
        slidesPerView: 2,
        slidesPerColumn: 2,
        spaceBetween: 10,
        slidesPerColumnFill:'row',
        pagination: {
          el: '.swppage1',
          clickable:true,
        },
      },
      detailList:{
        Details:[],
      },
      activeNames:[0,0,0,0,0,0],
      smsList:{
        imgData:'',
        session:'',
      },
      chatLink:'',
    }
  },
  methods:{
    goPage(num){
      if(num==1){
        window.open('https://www.linkedin.com/')
      }else if(num==2){
        window.open('https://www.instagram.com/')
      }else if(num==3){
        // window.open('https://twitter.com/')
        }else if(num==4){
        window.open('https://www.facebook.com/brotexacoustic')
      }
    },
    showform(){
      this.dialogFormVisible=true
      $request.getEnquiryCode().then(res=>{
        this.smsList=res.data
        // console.log(this.smsList)
      })
    },
    submit(){
      const is=this.formCheck(this.form,1)
      // console.log(is)
      if(is.is_ok==true){
        if(this.loading==false){
          this.loading=true
          $request.postForm2(this.form,this.smsList.session).then(res=>{
            this.loading=false
            if(res.code==200){
              this.$message({message: 'Successed!',type: 'success',offset:430,})
              setTimeout(()=>{
                this.$google()
              },2000)
            }else{
              this.$message({message: 'Failed!',type: 'error',offset:430,})
            }
          })
        }
      }else if(is.is_empty==true){
        // this.loading=false
        // this.$message.warning('The form can\'t be empty!');
        this.$message({message: 'The form can\'t be empty!',type: 'warning',offset:430,})
      }else if(is.email_ok!=true){
        this.$message({message: 'The mailbox format is incorrect!',type: 'error',offset:430,})
      }else{
        this.$message({message: 'Failed!',type: 'error',offset:430,})
      }
    },
    changeList(index,id){
      this.catList[index].onflag=!this.catList[index].onflag
      if(this.catList[index].onflag==true){//请求该列表
        console.log(id)
      }
    },
  },
  created() {
    this.$emit('getnav',1)
    $request.getShopsDet(this.$route.query.id).then(res=>{
      res.shopCustomProp.forEach(val=>{
        switch (val.name){
          case 'Details':
            val.list=val.value.split('||')
            this.detailList.Details=this.detailList.Details.concat(val)
            break;
          case 'Link':
            this.chatLink=val.value
            break;
        }
        // console.log(this.detailList)
      })
      this.proList=res
      // console.log(this.proList)
    })
    $request.getsomeShops(this.$route.query.id).then(res=>{
      this.relatedList=res
      console.log(this.relatedList)
    })
  },
  mounted() {
    this.$nextTick(()=>{
      let wow = new WOW({
        live:false
      })
      wow.init()
    })
  }
}
</script>

<style lang="less" scoped>
#page_productInfo{
  /*[id^='part']>.mainTitle1{margin-bottom: 50px;}*/
  .banner{height: 536px;position: relative;z-index: 1;padding: 230px 0 0 0px;text-align: center;overflow: hidden;
    .bg{position: absolute;bottom: 0;right: 0;z-index: -1;}
    .textbox{
      h2{color: white;width: 55%;margin: 0 auto;}
    }
    .crumb{font: 20px Poppins-SemiBold;margin-top: 60px;
      a{color: white;
        &:not(:last-child):after{content: '>';margin: 0 20px;}
        &:last-child{border-bottom: 1px solid white;}
      }
    }
  }
  #part1{display: flex;justify-content: space-between;flex-direction: column;
    .left{width: 100%;margin-bottom: .2rem;
      .mainimg{width: 100%;height: 2rem;object-fit: contain;border: 1px solid rgba(0,0,0,.2);}
      .imgbox{margin-top: 15px;
        .item{cursor: pointer;background: black;
          img{width: 100%;height: .5rem;object-fit: cover;opacity: .7;transition: .3s;
            &.on{opacity: 1;}
          }
        }
      }
    }
    .right{width: 100%;
      .textbox{
        h3{font: .2rem Poppins-Medium;color: @main-c4;padding: 0;
          &:before{display: none;}
        }
        p{width: 100%;padding: 0;}
      }
      dl{display: flex;justify-content: space-between;
        dd{width: 46%;font: 18px Poppins-Regular;
          &:first-child{color: @main-c4;}
          &:last-child{color: @main-c5;}
        }
      }
      .btnbox{margin-top: .2rem;display: flex;
        .mainBtn1{margin-right: 10px;}
      }
      .dialog{
        .mainTitle1{margin-bottom: 0;
          h3{padding-left: 5%;margin: 0;
            &:before{left: 0;}
          }
        }
        /deep/ .el-dialog{width: 100%;margin-top: .55rem!important;
          .el-dialog__header{padding: 20px;
            .el-dialog__headerbtn{background: white;border-radius: 50%;padding: 10px;width: 40px;height: 40px;
              i{font-size: 24px;color: @main-c2;position: relative;top: 50%;left: 50%;transform: translate(-50%,-50%);}
            }
          }
          .el-dialog__body{padding: .15rem .2rem 0;
            .el-form-item{margin-bottom: .10rem;}
            .el-form-item__content{display: flex;align-items: center;justify-content: space-between;
              &:before,&:after{display: none;}
              .el-input,.el-textarea{display: flex;justify-content: center;width: 48.5%;
                input,textarea{width: 100%;border: none;font: .14rem Helvetica;height: .38rem;background: #F5F5F5;
                  &::-webkit-input-placeholder{font: .14rem Poppins-Regular;color: #30475E;}
                }
                textarea{padding: 15px;resize: none;height: unset;}
                &.sms{width: 75%;justify-content: space-between;

                }
              }
              .el-textarea{width: 100%;}
              .smsimg{margin-left: 10px;height: 32px;object-fit: contain;}
            }
          }
          .el-dialog__footer{padding:0 .2rem 30px;text-align: left;

          }
        }
      }
      .sharebox{margin-top: .2rem;
        span{font: .14rem Ubuntu-B;}
        i{width: .25rem;height: .25rem;display: inline-flex;align-items: center;justify-content: center;border-radius: 50%;background: #C0C0C0;color: white;font-size: .14rem;margin: 0 10px;cursor: pointer;
          &:hover{background: @main-c1;}
        }
      }
    }
  }
  #part2{padding: 0px;
    .mainTitle1{border-bottom: 2px solid #F5F7F8;}
    dl{display: flex;justify-content: space-between;align-items: center;padding: 35px 280px;
      .left{width: 50%;display: flex;color: @main-c4;
        .num{font: 22px Poppins-SemiBold;padding: 0 35px;}
        .textbox{
          h4{font: 22px Poppins-SemiBold;margin-bottom: 10px;}
        }
      }
      .right{width: 40%;
        img{width: 100%;height: 250px;object-fit: cover;}
      }
      &:nth-child(2n){background: #F5F5F5;}
    }
  }
  .collapsebox{
    .probox{
      .mainTitle1{margin-bottom: 0;
        h3{margin-bottom: 0;padding-left: .2rem;}
      }
      /deep/ .el-collapse{
        .el-collapse-item__header{padding: 0 3%;
          &.is-active{border-bottom-color: #EBEEF5;}
        }
        .el-collapse-item__content{padding: .2rem calc(.2rem + 3%);}
        .el-collapse-item__wrap{border-bottom: none;}
      }
      dl{display: flex;align-items: center;justify-content: space-between;margin-bottom: .1rem;
        dd{width: calc(50% - .05rem);
          &:first-child{font:bold .12rem/.16rem Poppins-Regular;color: @main-c4;}
          &:last-child{font: .12rem/.16rem Poppins-Regular;color: #75808B;}
        }
      }
      &:not(:last-child){
        /deep/ .el-collapse{
          .el-collapse-item__header{border-bottom-color:transparent;
            &.is-active{border-bottom-color: #EBEEF5;}
          }
        }
      }
    }
    .detail{
      /deep/ .el-collapse{
        .el-collapse-item__content{padding: 0rem;}
      }
      dl{display: flex;justify-content: space-between;align-items: center;flex-direction: row-reverse;padding:.2rem;margin-bottom: 0;
        .left{width: 50%;display: flex;color: @main-c4;
          .num{font: .12rem Poppins-SemiBold;}
          .textbox{
            h4{font: .14rem/.18rem Poppins-SemiBold;margin-bottom: .05rem;}
          }
        }
        .right{width: 45%;
          img{width: 100%;height: 1.4rem;object-fit: cover;}
        }
        &:nth-child(2n){background: #F5F5F5;}
      }
    }
    .custom{color: @main-c4;
      .itembox{display: flex;justify-content: space-between;flex-wrap: wrap;flex-direction: column;
        .item{width: calc(100% - .4rem);position: relative;margin: 0 .2rem .2rem;padding-bottom: .2rem;display: flex;align-items: center;justify-content: space-between;
          img{width: .30rem;height: .30rem;}
          .textbox{width: calc(95% - .4rem);
            h4{font: .14rem Poppins-SemiBold;margin: 0 0 .05rem;}
            p{font: .12rem/.16rem Poppins-Regular;}
          }
          &:not(:last-child){border-bottom: 1px solid #CDCDCD;}
          &:last-child{margin-bottom: 0;padding-bottom: 0;}
        }
      }
    }
  }
  #part3{margin-top: .2rem;
    .itembox{display: flex;justify-content: space-between;flex-wrap: wrap;
      .item{width: calc(50% - .05rem);position: relative;margin:0 0 .1rem;
        img{width: 100%;height: 1.2rem;object-fit: cover;}
        .cover{position: absolute;width: calc(100%);background: linear-gradient(to bottom,transparent,rgba(0,0,0,.5));bottom: 0%;left:0%;display: flex;align-items: center;justify-content: center;
          font: .14rem Poppins-SemiBold;color: white;opacity: 1;transition: .6s;padding: .1rem 0 .05rem;
        }
        &:nth-last-child(-n+1){margin-bottom: 0;}
        //&:hover{
        //  .cover{opacity: 1;animation: bounceIn 1s;}
        //}
      }
    }
  }
  #part4{color: @main-c4;
    .itembox{display: flex;justify-content: space-between;flex-wrap: wrap;
      .item{width: calc(33.3333% - 23.33333px);position: relative;background: @main-c1;padding: 50px;
        h4{font: 22px Poppins-SemiBold;margin: 30px 0 20px;}
        p{font: 16px Poppins-Regular;}
      }
    }
  }
  #part5{
    .contentbox{position: relative;display: flex;justify-content: center;
      /deep/ .swiper-slide{height: unset;}
      .item{display: block;
        .imgbox{position: relative;overflow: hidden;
          .cover{position: absolute;opacity: 0;background: black;width: 100%;height: 100%;left: 0;top: 0;transition: .6s;}
          img{width: 100%;height: 1.15rem;object-fit: contain;border: 1px solid rgba(244,244,244,1);}
          .triangle-topleft{width: 0px;height: 0px;border-top: 40px solid @main-c1;border-right: 40px solid transparent;position: absolute;top: 0;left: -40px;transition: .3s;}
          .triangle-topright{width: 0px;height: 0px;border-bottom: 40px solid @main-c1;border-left: 40px solid transparent;position: absolute;bottom: 0;right: -40px;transition: .3s;}
        }
        p{font: .12rem Poppins-Medium;margin: .1rem 0 0;color: @main-c4;}
        &:hover{
          .cover{opacity: .2;}
          .imgbox{
            .triangle-topleft{left: 0;}
            .triangle-topright{right: 0;}
          }
          .mainBtn2{width: auto;padding: 0 15px;background: @main-c1;border-color: @main-c1;
            span{transform: translateX(0%);position: relative;margin-right: 10px;opacity: 1;}
          }
        }
      }
    }
  }
  #part6{
    .itembox{display: flex;justify-content: space-between;flex-wrap: wrap;
      .item{width: calc(100% / 6);position: relative;text-align: center;
        p{font: 20px Poppins-Medium;margin-top: 25px;color: @main-c4;}
      }
    }
  }
}
</style>